import type {PersonnelRecord} from '@/entities/personnel/types';

/**
 * Whether a terminal has a working face vector for a person — as THREE states,
 * because the wire has three.
 *
 * `unknown` is not decoration. `face_enrolled` is absent when no device has
 * reported on this person yet, or when the firmware predates 2026-08-18, and
 * rendering that silence as "no face" declares an entire company faceless the
 * moment one of its terminals is old.
 *
 * It cannot be derived from `face_template` either: the vector deliberately
 * never travels up — the photo is the source of truth and the board computes
 * the embedding itself — so the template is empty both for someone who walks
 * through the turnstile and for someone who cannot.
 */
export type FaceState = 'yes' | 'no' | 'unknown';

export function faceState(
  record: Pick<PersonnelRecord, 'face_enrolled'>,
): FaceState {
  if (record.face_enrolled === true) {
    return 'yes';
  }
  if (record.face_enrolled === false) {
    return 'no';
  }
  return 'unknown';
}
